export default "__VITE_ASSET__mLjbEC5w__"